import React from 'react';
import { useSelector } from 'react-redux';
import { getIsRestaurantNameDisplayed } from '../../redux/configuration/selectors';
import { getRestaurantName } from '../../redux/user/selectors';
import { Container, RestaurantName } from './CustomerDisplayFooter.style';

const CustomerDisplayFooter: React.FunctionComponent = () => {
    const isRestaurantNameDisplayed = useSelector(getIsRestaurantNameDisplayed);
    const restaurantName = useSelector(getRestaurantName);

    if (!isRestaurantNameDisplayed || !restaurantName) {
        return null;
    }

    return (
        <Container data-testid="customer-display-footer">
            <RestaurantName>{restaurantName}</RestaurantName>
        </Container>
    );
};

export default CustomerDisplayFooter;
